<div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()">
</div>
<div [formGroup]="resetPasswordForm" class="reset-password-container">
    <div class="accordion-class">
        <h5>Reset Password</h5>
        <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container">
        <div class="group">
            <div class="mtb w-100 pull-left" style="margin-bottom: 15px;">
                <span style="font-size: 14px; color: rgba(0,0,0,0.6);">Resetting password for: <strong>{{ data?.username }}</strong></span>
            </div>
            <div class="mtb w-100 pull-left">
                <mat-form-field>
                    <mat-label>Create New Password</mat-label>
                    <input matInput formControlName="password" type="text" required (keydown)="preventSpace($event)" autocomplete="off" [style.-webkit-text-security]="hide ? 'disc' : 'none'">
                    <mat-error>Please enter password</mat-error>
                </mat-form-field>
            </div>
            <div class="mtb w-100 pull-left">
                <mat-form-field>
                    <mat-label>Confirm Password</mat-label>
                    <input matInput formControlName="confirmPassword" type="text" required (keydown)="preventSpace($event)" autocomplete="off" [style.-webkit-text-security]="hide ? 'disc' : 'none'">
                    <mat-icon matSuffix class="ml-2" (click)="hide = !hide">{{hide ? 'visibility_off' :
                        'visibility'}}</mat-icon>
                    <mat-error>Please enter password</mat-error>
                </mat-form-field>
            </div>

        </div>
    </div>
    <button type="button" class="button buttonBlue" (click)="updatePassword()">Save</button>
</div>